/**
 * BUXTRADE — PRODUCT PAGE SCRIPTS
 * Asset: beetroot-product.js
 */

(function () {
  'use strict';

  if (window.__buxtradeProductInit) return;
  window.__buxtradeProductInit = true;

  /* ----------------------------------------------------------
     PURCHASE TOGGLE — Subscribe vs One-Time
     ---------------------------------------------------------- */
  function initPurchaseToggle() {
    var options = document.querySelectorAll('.purchase-toggle__option');
    if (!options.length) return;

    options.forEach(function (btn) {
      btn.addEventListener('click', function () {
        options.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');

        // Update the hidden selling_plan input for Shopify cart
        var isSubscription = btn.dataset.type === 'subscription';
        var spInput = document.getElementById('beet-selling-plan');
        if (spInput) {
          spInput.value = isSubscription ? (spInput.dataset.planId || '') : '';
        }

        // Update ATC button text
        var atcBtn = document.getElementById('beet-atc-btn');
        if (atcBtn) {
          atcBtn.textContent = isSubscription ? 'Subscribe & Save →' : 'Add to Cart →';
        }
      });
    });
  }

  /* ----------------------------------------------------------
     VARIANT SELECTOR
     ---------------------------------------------------------- */
  function initVariantSelector() {
    var btns = document.querySelectorAll('.variant-btn');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        // Deactivate siblings in same group
        var group = btn.closest('.variant-selector__options');
        if (group) {
          group.querySelectorAll('.variant-btn').forEach(function (b) {
            b.classList.remove('active');
          });
        }
        btn.classList.add('active');

        // Update the variant ID input
        var variantInput = document.getElementById('beet-variant-id');
        if (variantInput && btn.dataset.variantId) {
          variantInput.value = btn.dataset.variantId;
        }

        // Update displayed price
        var priceEl = document.querySelector('.purchase-toggle__option[data-type="one-time"] .purchase-toggle__option-price');
        if (priceEl && btn.dataset.price) {
          priceEl.textContent = btn.dataset.price;
        }

        // Update sticky bar price
        var stickyPrice = document.querySelector('.sticky-atc__price');
        if (stickyPrice && btn.dataset.price) {
          stickyPrice.textContent = btn.dataset.price;
        }
      });
    });
  }

  /* ----------------------------------------------------------
     QUANTITY SELECTOR
     ---------------------------------------------------------- */
  function initQtySelector() {
    var minusBtn = document.getElementById('beet-qty-minus');
    var plusBtn  = document.getElementById('beet-qty-plus');
    var input    = document.getElementById('beet-qty-input');
    if (!minusBtn || !plusBtn || !input) return;

    plusBtn.addEventListener('click', function () {
      var val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
    });
    minusBtn.addEventListener('click', function () {
      var val = parseInt(input.value, 10) || 1;
      if (val > 1) input.value = val - 1;
    });
    input.addEventListener('change', function () {
      if (parseInt(input.value, 10) < 1 || isNaN(parseInt(input.value, 10))) {
        input.value = 1;
      }
    });
  }

  /* ----------------------------------------------------------
     ADD TO CART — Ajax submission
     ---------------------------------------------------------- */
  function initAddToCart() {
    var form = document.getElementById('beet-product-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var btn = document.getElementById('beet-atc-btn');
      var stickyBtn = document.querySelector('.sticky-atc__btn');
      var originalText = btn ? btn.textContent : 'Add to Cart →';

      if (btn) { btn.textContent = 'Adding…'; btn.classList.add('btn-atc--loading'); }

      var variantId   = document.getElementById('beet-variant-id');
      var qty         = document.getElementById('beet-qty-input');
      var sellingPlan = document.getElementById('beet-selling-plan');

      var body = {
        items: [{
          id:       variantId  ? parseInt(variantId.value, 10)   : null,
          quantity: qty        ? parseInt(qty.value, 10)         : 1,
        }]
      };

      if (sellingPlan && sellingPlan.value) {
        body.items[0].selling_plan = parseInt(sellingPlan.value, 10);
      }

      fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body:    JSON.stringify(body)
      })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          // Error from Shopify
          alert(data.description || 'Could not add to cart. Please try again.');
          if (btn) { btn.textContent = originalText; btn.classList.remove('btn-atc--loading'); }
          return;
        }
        // Success — open cart drawer or redirect
        if (btn)       { btn.textContent = '✓ Added!'; btn.classList.remove('btn-atc--loading'); }
        if (stickyBtn) { stickyBtn.textContent = '✓ Added!'; }

        // Update cart count badge if theme has one
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var badge = document.querySelector('[data-cart-count], .cart-count, #CartCount');
            if (badge) badge.textContent = cart.item_count;
            // If theme uses a cart drawer, trigger it
            document.dispatchEvent(new CustomEvent('beet:cart:updated', { detail: cart }));
          });

        // Reset button after 2.5 s
        setTimeout(function () {
          if (btn) { btn.textContent = originalText; }
          if (stickyBtn) { stickyBtn.textContent = 'Add to Cart'; }
        }, 2500);
      })
      .catch(function () {
        alert('Something went wrong. Please try again.');
        if (btn) { btn.textContent = originalText; btn.classList.remove('btn-atc--loading'); }
      });
    });

    // Sticky bar button triggers the same form
    var stickyBtn = document.querySelector('.sticky-atc__btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  }

  /* ----------------------------------------------------------
     STICKY ADD TO CART BAR
     ---------------------------------------------------------- */
  function initStickyBar() {
    var bar    = document.getElementById('beet-sticky-atc');
    var buybox = document.getElementById('beet-atc-btn');
    if (!bar || !buybox) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('visible', !entry.isIntersecting);
      });
    }, { threshold: 0.1 });

    observer.observe(buybox);
  }

  /* ----------------------------------------------------------
     INFO ACCORDION (Ingredients page)
     ---------------------------------------------------------- */
  function initInfoAccordion() {
    document.querySelectorAll('.info-accordion__trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body  = btn.nextElementSibling;
        var isOpen = btn.classList.contains('open');

        document.querySelectorAll('.info-accordion__trigger.open').forEach(function (b) {
          b.classList.remove('open');
          b.nextElementSibling.classList.remove('open');
        });

        if (!isOpen) {
          btn.classList.add('open');
          body.classList.add('open');
        }
      });
    });
  }

  /* ----------------------------------------------------------
     SHOPIFY SECTION RE-INIT
     ---------------------------------------------------------- */
  document.addEventListener('shopify:section:load', function () {
    window.__buxtradeProductInit = false;
    boot();
    window.__buxtradeProductInit = true;
  });

  /* ----------------------------------------------------------
     BOOT
     ---------------------------------------------------------- */
  function boot() {
    initPurchaseToggle();
    initVariantSelector();
    initQtySelector();
    initAddToCart();
    initStickyBar();
    initInfoAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
